<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <!-- Kit Type Dialog (create / edit) -->
    <v-dialog v-model="kitDialog" max-width="1000" persistent>
      <v-card>
        <v-toolbar dark color="secondary">
          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeKitDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-form ref="kitForm" v-model="kitFormValidado">
              <v-alert type="info" dense class="mb-4">
                {{ $t('equipment.kit.typeDescription') }}
              </v-alert>
              <v-row>
                <v-col cols="12" sm="10" md="10">
                  <v-text-field v-model="kitItem.nome_kit"
                    :label="$t('equipment.kit.typeName') || 'Kit Type Name'"
                    :rules="[(v) => !!v || ($t('equipment.kit.nameRequired'))]">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="1" md="1">
                  <v-switch v-model="kitIsAtivo" class="ma-2" :label="$t('equipment.active')"></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card outlined>
                    <v-card-title>
                      {{ $t('equipment.kit.selectEquipmentTypes') }}
                    </v-card-title>
                    <v-card-text>
                      <div v-for="(row, index) in kitItem.equipmentTypeRows" :key="index" class="mb-4">
                        <v-row align="center">
                          <v-col cols="12" sm="5" md="5" class="d-flex align-center">
                            <v-autocomplete
                              v-model="row.id_tipo_equipamento"
                              :items="getAvailableTiposForRow(index)"
                              item-text="nome_tipo_equipamento"
                              item-value="id_tipo_equipamento"
                              :label="$t('equipment.kit.equipmentTypes')"
                              clearable
                              outlined
                              dense
                              hide-details
                              class="flex-grow-1"
                              :filter="(item, queryText) => {
                                const name = item.nome_tipo_equipamento ? item.nome_tipo_equipamento.toLowerCase() : '';
                                const searchText = queryText.toLowerCase();
                                return name.includes(searchText);
                              }"
                            >
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.nome_tipo_equipamento }}</v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="5" md="5" class="d-flex align-center">
                            <v-text-field
                              v-model.number="row.quantidade"
                              type="number"
                              min="1"
                              :label="getQuantityLabel(row)"
                              outlined
                              dense
                              hide-details
                              class="flex-grow-1"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="1" md="1" class="d-flex align-center justify-center">
                            <v-btn
                              icon
                              small
                              @click="removeKitTypeRow(index)"
                              :disabled="kitItem.equipmentTypeRows.length <= 1"
                            >
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                      <v-btn
                        color="primary"
                        @click="addKitTypeRow"
                        class="mt-2"
                      >
                        <v-icon left>mdi-plus</v-icon>
                        {{ $t('equipment.kit.addType') }}
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeKitDialog">
            {{ $t('button.cancel') }}
          </v-btn>
          <v-btn color="primary" @click="saveKit" :disabled="!kitFormValidado || savingKit" :loading="savingKit">
            {{ $t('button.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirm Delete Dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span style="color: #d60000">{{ $t('system.alert') }}</span>
        </v-card-title>
        <v-card-text>
          <span style="color: #d60000">{{ mensagemdialog }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{ messageDismissButton }}</v-btn>
          <v-btn v-if="showConfirmButton" color="primary" class="white--text" @click="confirmDeleteTipoKit" :loading="deletingTipoKit">{{ messageConfirmButton }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Tipos de Kit Table -->
    <merus-data-table :headers="kitTypeHeaders" :items="tiposKits" :mostrar-inativos="mostrarInativos" :loading="loadingTable" :default-multi-sort="defaultSort"
      :loading-text="$t('equipment.kit.loading')"

 cod-tabela="TIPOSKITS_KIT_TYPE" @update:headers="kitTypeHeaders = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('equipment.kit.typesScreenTitle')" :token="token" :items="tiposKitsFiltrados"
          :csv-title="$t('equipment.kit.typesScreenTitle')" :pdf-title="$t('equipment.kit.typesScreenTitle')" :pdf-headers="kitTypeHeaders"
          :pdf-filename="$t('equipment.kit.typesScreenTitle')" hide-search>
          <template v-slot:extension>
            <v-switch
              v-model="mostrarInativos"
              :label="$t('crudVeiculos.showInactive')"
              class="ml-3 mr-4"
              hide-details
            ></v-switch>
          </template>
          <template v-slot:add>
            <v-btn color="primary" dark small class="mb-2 mr-2" @click="openCreateDialog" fab>
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.ativo_extenso="{ item }">
        <v-chip small :color="item.ativo === 1 ? 'green' : 'grey'" dark>
          {{ item.ativo === 1 ? $t('system.yes') : $t('system.no') }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editTipoKit(item)">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteTipoKit(item)">mdi-delete</v-icon>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import EventBus from "@/utils/eventBus";

export default {
  name: "CRUDTiposKits",
  components: {
    MerusDataTable,
    CadastroToolbar
  },
  data: () => ({
    kitTypeHeaders: [],
    token: null,
    showConfirmButton: true,
    kitDialog: false,
    kitFormValidado: true,
    savingKit: false,
    kitIsAtivo: true,
    editedIndex: -1,
    confirmDialog: false,
    mensagemdialog: "",
    messageDismissButton: "",
    messageConfirmButton: "",
    loadingTable: true,
    tiposKits: [],
    mostrarInativos: false,
    empresas: [],
    tiposequipamentos: [],
    kitItem: {
      id_tipo_kit: null,
      nome_kit: null,
      ativo: 1,
      equipmentTypeRows: [{ id_tipo_equipamento: null, quantidade: 1, controla_inventario: 1 }]
    },
    defaultKitItem: {
      id_tipo_kit: null,
      nome_kit: null,
      ativo: 1,
      equipmentTypeRows: [{ id_tipo_equipamento: null, quantidade: 1, controla_inventario: 1 }]
    },
    tipoKitToDelete: null,
    deletingTipoKit: false
  }),
  computed: {
    tiposKitsFiltrados() {
      if (!this.mostrarInativos) {
        return this.tiposKits.filter((t) => t.ativo === true || t.ativo === 1);
      }
      return this.tiposKits;
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$t("equipment.kit.createKitType") : this.$t("equipment.kit.editKitType");
    },
    defaultSort() {
      return [
        { value: "nome_kit", options: { text: this.$t("routs.increasing"), value: 1 } }
      ];
    }
  },
  created() {
    this.token = sessionStorage.getItem("api");
    this.messageDismissButton = this.$t("button.dismiss");
    this.messageConfirmButton = this.$t("button.confirm");
    this.populaTiposEquipamentos();
    this.populaTiposKits();
  },
  methods: {

    populaTiposEquipamentos() {
      apiController.request(apiController.endpoints.getallTiposequipamentos, {
        onSuccess: (response) => {
          this.tiposequipamentos = response.data;
        },
      });
    },
    populaTiposKits() {
      apiController.request(apiController.endpoints.getallTiposkits, {
        onSuccess: (response) => {
          this.tiposKits = response.data;
          this.loadingTable = false;
        },
        onError: () => {
          this.loadingTable = false;
        },
      });
    },
    getAvailableTiposForRow(rowIndex) {
      let rows = this.kitItem.equipmentTypeRows || [];
      const selectedIds = rows
        .map((r, i) => (i !== rowIndex ? r.id_tipo_equipamento : null))
        .filter((id) => id != null);
      if (!this.tiposequipamentos || !this.tiposequipamentos.length) return [];
      return this.tiposequipamentos.filter((t) => !selectedIds.includes(t.id_tipo_equipamento));
    },
    getEquipmentTypeUnit(idTipoEquipamento) {
      if (!idTipoEquipamento || !Array.isArray(this.tiposequipamentos)) return "";
      const id = typeof idTipoEquipamento === "number" ? idTipoEquipamento : parseInt(idTipoEquipamento, 10);
      const tipo = this.tiposequipamentos.find((t) => {
        const tipoId = typeof t.id_tipo_equipamento === "number" ? t.id_tipo_equipamento : parseInt(t.id_tipo_equipamento, 10);
        return tipoId === id;
      });
      return tipo && tipo.nome_unidade_equipamento ? tipo.nome_unidade_equipamento : "";
    },
    getQuantityLabel(row) {
      const baseLabel = this.$t("equipment.kit.quantityPerType");
      const unidade = row && row.id_tipo_equipamento ? this.getEquipmentTypeUnit(row.id_tipo_equipamento) : "";
      return unidade ? `${baseLabel} (${unidade}/s)` : baseLabel;
    },
    addKitTypeRow() {
      this.kitItem.equipmentTypeRows.push({ id_tipo_equipamento: null, quantidade: 1, controla_inventario: 1 });
    },
    removeKitTypeRow(index) {
      if (this.kitItem.equipmentTypeRows.length <= 1) return;
      this.kitItem.equipmentTypeRows.splice(index, 1);
    },
    openCreateDialog() {
      this.editedIndex = -1;
      this.kitItem = Object.assign({}, this.defaultKitItem);
      this.kitItem.equipmentTypeRows = [{ id_tipo_equipamento: null, quantidade: 1, controla_inventario: 1 }];
      this.kitIsAtivo = true;
      this.kitDialog = true;
    },
    closeKitDialog() {
      this.kitDialog = false;
      this.$nextTick(() => {
        this.kitItem = Object.assign({}, this.defaultKitItem);
        this.kitItem.equipmentTypeRows = [{ id_tipo_equipamento: null, quantidade: 1, controla_inventario: 1 }];
        this.kitIsAtivo = true;
        this.editedIndex = -1;
        if (this.$refs.kitForm) {
          this.$refs.kitForm.resetValidation();
        }
      });
    },
    saveKit() {
      this.$refs.kitForm.validate();
      if (!this.kitFormValidado) return;
      let rowsWithType = (this.kitItem.equipmentTypeRows || []).filter((r) => r.id_tipo_equipamento != null);
      if (rowsWithType.length === 0) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("equipment.kit.equipmentTypesRequired"),
          tipo: "error"
        });
        return;
      }
      const ativo = this.kitIsAtivo ? 1 : 0;
      const tipos_equipamentos = rowsWithType.map((r) => ({
        id_tipo_equipamento: r.id_tipo_equipamento,
        quantidade: r.quantidade != null && r.quantidade >= 1 ? r.quantidade : 1,
        controla_inventario: 1
      }));

      if (this.editedIndex === -1) {
        const kitTypeData = {
          nome_kit: this.kitItem.nome_kit,
          ativo,
          tipos_equipamentos
        };
        this.savingKit = true;
        apiController.request(apiController.endpoints.insertKittipo, {
          data: kitTypeData,
          onSuccess: (response) => {
            this.savingKit = false;
            if (response.data.erro) {
              EventBus.$emit("show-alert", {
                mensagem: response.data.mensagem || this.$t("equipment.kit.error.create"),
                tipo: "error"
              });
            } else {
              EventBus.$emit("show-alert", {
                mensagem: this.$t("equipment.kit.success.created"),
                tipo: "success"
              });
              this.closeKitDialog();
              this.populaTiposKits();
            }
          },
          onError: () => {
            this.savingKit = false;
          },
        });
      } else {
        const kitTypeData = {
          id_tipo_kit: this.kitItem.id_tipo_kit,
          nome_kit: this.kitItem.nome_kit,
          ativo,
          tipos_equipamentos
        };
        this.savingKit = true;
        apiController.request(apiController.endpoints.updateTipokit, {
          data: kitTypeData,
          onSuccess: (response) => {
            this.savingKit = false;
            if (response.data.erro) {
              EventBus.$emit("show-alert", {
                mensagem: response.data.mensagem || this.$t("equipment.kit.error.updateType"),
                tipo: "error"
              });
            } else {
              EventBus.$emit("show-alert", {
                mensagem: this.$t("equipment.kit.success.updatedType"),
                tipo: "success"
              });
              this.closeKitDialog();
              this.populaTiposKits();
            }
          },
          onError: () => {
            this.savingKit = false;
          },
        });
      }
    },
    editTipoKit(item) {
      apiController.request(apiController.endpoints.getTipokitbyid, {
        params: { id: item.id_tipo_kit },
        onSuccess: (response) => {
          const data = response.data;
          if (!data) {
            EventBus.$emit("show-alert", {
              mensagem: this.$t("equipment.kit.error.loadType"),
              tipo: "error"
            });
            return;
          }
          const ids = data.tipos_equipamentos_ids || [];
          const quantidades = data.tipos_equipamentos_quantidades || [];
          const equipmentTypeRows = ids.length
            ? ids.map((id, i) => {
                const qty = quantidades[i] != null && quantidades[i] >= 1
                  ? (typeof quantidades[i] === "number" ? quantidades[i] : parseInt(quantidades[i], 10))
                  : 1;
                return {
                  id_tipo_equipamento: typeof id === "number" ? id : parseInt(id, 10),
                  quantidade: qty,
                  controla_inventario: 1
                };
              })
            : [{ id_tipo_equipamento: null, quantidade: 1, controla_inventario: 1 }];
          this.kitItem = {
            id_tipo_kit: data.id_tipo_kit,
            nome_kit: data.nome_kit,
            ativo: data.ativo,
            equipmentTypeRows
          };
          this.kitIsAtivo = data.ativo === 1;
          this.editedIndex = this.tiposKits.findIndex((t) => t.id_tipo_kit === item.id_tipo_kit);
          this.kitDialog = true;
        },
      });
    },
    deleteTipoKit(item) {
      this.tipoKitToDelete = item;
      this.mensagemdialog = this.$t("equipment.kit.confirmDeleteType", { name: item.nome_kit || item.id_tipo_kit });
      this.showConfirmButton = true;
      this.confirmDialog = true;
    },
    confirmDeleteTipoKit() {
      if (!this.tipoKitToDelete || !this.tipoKitToDelete.id_tipo_kit) {
        this.confirmDialog = false;
        this.tipoKitToDelete = null;
        return;
      }
      this.deletingTipoKit = true;
      apiController.request(apiController.endpoints.deleteTipokit, {
        params: { id: this.tipoKitToDelete.id_tipo_kit },
        onSuccess: (response) => {
          this.deletingTipoKit = false;
          this.confirmDialog = false;
          this.tipoKitToDelete = null;
          if (response.data.erro) {
            EventBus.$emit("show-alert", {
              mensagem: response.data.mensagem || this.$t("equipment.kit.error.deleteType"),
              tipo: "error"
            });
          } else {
            EventBus.$emit("show-alert", {
              mensagem: this.$t("equipment.kit.success.deletedType"),
              tipo: "success"
            });
            this.populaTiposKits();
          }
        },
        onError: () => {
          this.deletingTipoKit = false;
        },
      });
    }
  }
};
</script>
